export { COOKIE_NAME, ONE_YEAR_MS } from "@shared/const";

// Login URL always points to Firebase Auth login page
export const getLoginUrl = () => "/login";
